<template>
  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="col-12"> 
        <div class="card">
          <div class="card-header border-bottom">
            <div class="user d-flex align-items-center">
              <div class="col-6">
                <h5 class="mb-0">Customers</h5>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table id="datatable-search" class="table table-flush table-bordered">
              <thead class="thead-light">
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Status</th>
                  <th>Created At</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="users.length === 0">
                  <td colspan="5" class="text-center">No users found.</td>
                </tr>
                <tr v-for="user in users" :key="user.id">
                  <td>{{ user.name }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ user.status }}</td>
                  <td>{{ formatDate(user.created_at) }}</td>
                  <td>
                    <button @click="editUser(user.id, user.email)" class="btn btn-primary btn-sm">Edit</button>
                    <button v-if="user.status === 'Inactive'" @click="enableUser(user.id)" class="btn btn-success btn-sm">Enable</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import userService from "@/services/users.service";
import Swal from 'sweetalert2';

export default {
  name: 'CustomerList',
  data() {
    return {
      users: [],
      dataTable: null,
    };
  },

  async mounted() {
    await this.fetchUsers();
  },

  methods: {
    async fetchUsers() {
      try {
        const response = await userService.getCustomers();
        this.users = response;
        console.log('=== CUSTOMERS LOADED ===');
        console.log('Number of customers:', this.users.length);
        console.log('Sample customer data:', this.users.slice(0, 2));
        this.initializeDataTable();
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString();
    },

    editUser(userId, email) {
      console.log('=== EDIT USER CALLED ===');
      console.log('UserID:', userId, '(Type:', typeof userId, ')');
      console.log('Email:', email, '(Type:', typeof email, ')');
      console.log('Email is null?', email === null);
      console.log('Email is undefined?', email === undefined);
      console.log('Email is empty?', email === '');
      
      if (!userId) {
        console.error('ERROR: userId is missing!');
        alert('Error: User ID is missing');
        return;
      }
      
      if (!email) {
        console.error('ERROR: email is missing!');
        alert('Error: Email is missing');
        return;
      }

      const dataObject = { userId, email };
      console.log('Data object to encode:', dataObject);
      
      const jsonString = JSON.stringify(dataObject);
      console.log('JSON string:', jsonString);
      
      const encodedData = btoa(jsonString);
      console.log('Encoded data:', encodedData);
      console.log('Encoded data length:', encodedData.length);
      
      // Test decoding to verify
      try {
        const testDecode = JSON.parse(atob(encodedData));
        console.log('Test decode successful:', testDecode);
      } catch (decodeError) {
        console.error('ERROR: Test decode failed!', decodeError);
        return;
      }
      
      this.$router.push({ name: 'EditCustomer', params: { id: encodedData } });
    },

    async enableUser(userId) {
      console.log('=== ENABLE USER CALLED ===');
      console.log('UserID:', userId);
      
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Do you want to enable this customer?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#28a745', // green for enable
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, enable!',
      });

      if (result.isConfirmed) {
        try {
          await userService.enableUser(userId);

          // Update the user's status to "Active" in the local list
          const user = this.users.find(user => user.id === userId);
          if (user) {
            user.status = 'Active'; // or 1, depending on your frontend logic
          }

          this.refreshDataTable();

          Swal.fire('Enabled!', 'The customer has been enabled.', 'success');
        } catch (error) {
          console.error(`Error enabling user with ID: ${userId}`, error);
          Swal.fire('Error!', 'There was an error enabling the user. Please try again.', 'error');
        }
      }
    },

    initializeDataTable() {
      this.$nextTick(() => {
        if ($.fn.DataTable.isDataTable('#datatable-search')) {
          $('#datatable-search').DataTable().destroy();
        }

        this.dataTable = $('#datatable-search').DataTable({
          paging: true,
          searching: true,
          info: true,
          data: this.users,
          columns: [
            { data: 'name' },
            { data: 'email' },
            { data: 'status' },
            {
              data: 'created_at',
              render: data => this.formatDate(data)
            },
            {
              data: null,
              render: (data, type, row) => {
                console.log('=== DATATABLE RENDER ===');
                console.log('Row data:', row);
                console.log('Row ID:', row.id);
                console.log('Row Email:', row.email);
                
                // KORRIGIERT: Beide Parameter übergeben
                const editBtn = `<button class='btn btn-primary btn-sm edit-btn' data-id='${row.id}' data-email='${row.email}'>Edit</button>`;
                const enableBtn = row.status === 'Inactive'
                  ? ` <button class='btn btn-success btn-sm enable-btn' data-id='${row.id}'>Enable</button>`
                  : '';
                return editBtn + enableBtn;
              }
            }
          ],
          createdRow: (row, data) => {
            console.log('=== DATATABLE CREATED ROW ===');
            console.log('Data for row:', data);
            
            // KORRIGIERT: Beide Parameter aus data-attributes lesen
            $(row).find('.edit-btn').on('click', (e) => {
              const userId = $(e.target).data('id');
              const email = $(e.target).data('email');
              console.log('DataTable edit clicked - ID:', userId, 'Email:', email);
              this.editUser(userId, email);
            });

            if (data.status === 'Inactive') {
              $(row).find('.enable-btn').on('click', (e) => {
                const userId = $(e.target).data('id');
                console.log('DataTable enable clicked - ID:', userId);
                this.enableUser(userId);
              });
            }
          },
          drawCallback: () => {
            this.applyCustomBorders();
          }
        });
      });
    },

    refreshDataTable() {
      if (this.dataTable) {
        this.dataTable.clear().rows.add(this.users).draw();
      }
    },

    applyCustomBorders() {
      $('#datatable-search th, #datatable-search td').css({
        'border': '1px solid #ddd',
        'padding': '10px',
      });

      $('#datatable-search td:first-child, #datatable-search th:first-child').css({
        'border-left': '2px solid #ddd',
      });

      $('#datatable-search th').css({
        'border-top': '2px solid #ddd',
      });
    },
  },
};
</script>

<style scoped>
/* Ensure table layout is fixed for better rendering */
#datatable-search {
  table-layout: fixed;
  width: 100%;
}

/* Apply general borders for table header and data cells */
#datatable-search th, #datatable-search td {
  border: 1px solid #ddd !important;  /* Ensure borders are applied with high priority */
  padding: 10px;
}

/* Apply a thicker left border to the first column */
#datatable-search td:first-child, #datatable-search th:first-child {
  border-left: 2px solid #ddd !important;
}

/* Apply a thicker top border to the header row */
#datatable-search th {
  border-top: 2px solid #ddd !important;
}

/* Optional: Style for table buttons */
#datatable-search td button {
  margin-right: 5px;
}
</style>